import { AfterViewInit, Directive, Input } from '@angular/core';
import { MatRadioButton } from '@angular/material/radio';

@Directive({
  selector: 'mat-radio-button[forceRadioName]',
  standalone: true,
})
export class ForceRadioNameDirective implements AfterViewInit {
  @Input() forceRadioName: string;

  constructor(private readonly el: MatRadioButton) {}

  ngAfterViewInit(): void {
    const inputEl = (
      this.el?._inputElement?.nativeElement as HTMLElement
    )?.querySelector(`input[name="${this.el?.name}"]`);

    if (this.forceRadioName) {
      inputEl?.setAttribute('name', this.forceRadioName);
    }
  }
}
